module.exports = __webpack_public_path__ + "static/img/picc.054e792.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/student/picc.png
// module id = BuW+
// module chunks = 1